/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Address } from './Address';
import {
    AddressFromJSON,
    AddressFromJSONTyped,
    AddressToJSON,
    AddressToJSONTyped,
} from './Address';
import type { Contact } from './Contact';
import {
    ContactFromJSON,
    ContactFromJSONTyped,
    ContactToJSON,
    ContactToJSONTyped,
} from './Contact';

/**
 * 
 * @export
 * @interface PrimaryCareProvider
 */
export interface PrimaryCareProvider {
    /**
     * Provider's first name
     */
    first_name?: string;
    /**
     * Provider's last name or organization name
     */
    last_or_org_name?: string;
    /**
     * 
     */
    address?: Address;
    /**
     * National Provider Identifier
     */
    npi?: string;
    /**
     * 
     */
    contacts?: Array<Contact>;
}

/**
 * Check if a given object implements the PrimaryCareProvider interface.
 */
export function instanceOfPrimaryCareProvider(value: object): value is PrimaryCareProvider {
    return true;
}

export function PrimaryCareProviderFromJSON(json: any): PrimaryCareProvider {
    return PrimaryCareProviderFromJSONTyped(json, false);
}

export function PrimaryCareProviderFromJSONTyped(json: any, ignoreDiscriminator: boolean): PrimaryCareProvider {
    if (json == null) {
        return json;
    }
    return {
        
        'first_name': json['first_name'] == null ? undefined : json['first_name'],
        'last_or_org_name': json['last_or_org_name'] == null ? undefined : json['last_or_org_name'],
        'address': json['address'] == null ? undefined : AddressFromJSON(json['address']),
        'npi': json['npi'] == null ? undefined : json['npi'],
        'contacts': json['contacts'] == null ? undefined : ((json['contacts'] as Array<any>).map(ContactFromJSON)),
    };
}

export function PrimaryCareProviderToJSON(json: any): PrimaryCareProvider {
    return PrimaryCareProviderToJSONTyped(json, false);
}

export function PrimaryCareProviderToJSONTyped(value?: PrimaryCareProvider | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'first_name': value['first_name'],
        'last_or_org_name': value['last_or_org_name'],
        'address': AddressToJSON(value['address']),
        'npi': value['npi'],
        'contacts': value['contacts'] == null ? undefined : ((value['contacts'] as Array<any>).map(ContactToJSON)),
    };
}

